module.exports = __webpack_public_path__ + "static/img/12.66a1e6d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/eng/12.png
// module id = 8S5v
// module chunks = 0